import {
  Box,
  Button,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  useMediaQuery,
} from "@mui/material";
import { useState } from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const STEPS = [
  { key: "hotelInfo", labelKey: "StepHotelInfo" },
  { key: "licenseVerification", labelKey: "StepLicenseVerification" },
  { key: "roomInfo", labelKey: "StepRoomInfo" },
  { key: "additionalInfo", labelKey: "StepAdditionalInfo" },
  { key: "paymentMethod", labelKey: "StepPaymentMethod" },
];

const CURRENT_STEP_INDEX = 2;
let customPromotionIdCounter = 1;

const HotelAdd_RoomInfo_3 = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:950px)");

  const [promotionChoice, setPromotionChoice] = useState("");
  const [earlyBirdDiscount, setEarlyBirdDiscount] = useState("");
  const [addonDiscount, setAddonDiscount] = useState("");
  const [customPromotions, setCustomPromotions] = useState([
    { id: customPromotionIdCounter, discount: "", label: "" },
  ]);

  const addCustomPromotion = () => {
    customPromotionIdCounter += 1;
    setCustomPromotions((prev) => [...prev, { id: customPromotionIdCounter, discount: "", label: "" }]);
  };

  const updateCustomPromotion = (id, field, value) => {
    setCustomPromotions((prev) =>
      prev.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  const discountFieldSx = {
    width: isMobile ? "70px" : "90px",
    minWidth: isMobile ? "70px" : "90px",
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#FFFFFF",
      borderRadius: "10px",
    },
  };

  const customLabelFieldSx = {
    width: isMobile ? "150px" : "260px",
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#FFFFFF",
      borderRadius: "10px",
    },
  };

  const radioSx = {
    color: "#D1D1D1",
    "&.Mui-checked": { color: "#31BACD" },
  };

  const isNextDisabled =
    !promotionChoice ||
    (promotionChoice === "earlyBird" && !earlyBirdDiscount) ||
    (promotionChoice === "addon" && !addonDiscount) ||
    (promotionChoice.startsWith("custom-") &&
      !customPromotions.find((row) => `custom-${row.id}` === promotionChoice)?.discount);

  const pageStyle = {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundColor: "#F5F5F5",
  };

  const contentStyle = {
    flex: "1 0 auto",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    padding: isMobile ? "100px 20px 60px" : "120px 80px 80px",
    maxWidth: "1600px",
    width: "100%",
  };

  return (
    <div style={pageStyle}>
      <Navbar />
      <div style={contentStyle}>
        {/* Stepper */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 6, mx: "auto" }}>
          {STEPS.map((step, index) => (
            <Box key={step.key} sx={{ display: "flex", alignItems: "center", flex: 1 }}>
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
                <Box
                  sx={{
                    width: isMobile ? "20px" : "30px",
                    height: isMobile ? "20px" : "30px",
                    borderRadius: "50%",
                    backgroundColor: index <= CURRENT_STEP_INDEX ? "#31BACD" : "transparent",
                    border: index <= CURRENT_STEP_INDEX ? "3px solid #fff" : "2px solid #D1D1D1",
                    boxShadow: index <= CURRENT_STEP_INDEX ? "0 0 0 2px #31BACD" : "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                />
                <Typography
                  sx={{
                    fontSize: isMobile ? "10px" : "13px",
                    fontWeight: index === CURRENT_STEP_INDEX ? "600" : "400",
                    color: index === CURRENT_STEP_INDEX ? "#000" : "#666",
                    textAlign: "center",
                    whiteSpace: "wrap",
                    width: isMobile ? "50px" : "100px",
                  }}
                >
                  {t(step.labelKey)}
                </Typography>
              </Box>
              {index < STEPS.length - 1 && (
                <Box
                  sx={{
                    height: "1px",
                    width: isMobile ? "30px" : "200px",
                    backgroundColor: "#D1D1D1",
                    mx: "auto",
                    mb: isMobile ? "18px" : "24px",
                  }}
                />
              )}
            </Box>
          ))}
        </Box>

        <Box sx={{ width: isMobile ? "100%" : "60%", mx: "auto", display: "flex", flexDirection: "column" }}>
          {/* Heading */}
          <Typography sx={{ fontWeight: "bold", fontSize: isMobile ? "20px" : "24px", color: "#000", mb: 4, display: "flex", alignItems: "center", gap: 1 }}>
            {t('RoomInfoStep3Title')}
            <Box component="span" sx={{ fontWeight: "400", fontSize: isMobile ? "12px" : "14px", color: "#666" }}>
              {t('MustFill')} <span style={{ color: "red" }}>*</span><span> )</span>
            </Box>
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%" }}>
            <Typography sx={{ fontWeight: "600", fontSize: isMobile ? "14px" : "16px", color: "#000" }}>
              {t('PromotionQuestionLabel')} <span style={{ color: "red" }}> *</span>
            </Typography>

            <RadioGroup
              value={promotionChoice}
              onChange={(e) => setPromotionChoice(e.target.value)}
            >
              <FormControlLabel
                value="none"
                control={<Radio sx={radioSx} />}
                label={t('NoPromotionLabel')}
                sx={{ color: "#000", fontSize: isMobile ? "14px" : "16px", py: 1 }}
              />

              <Box sx={{ display: "flex", alignItems: "center", gap: 2, py: 1 }}>
                <FormControlLabel
                  value="earlyBird"
                  control={<Radio sx={radioSx} />}
                  label=""
                  sx={{ mr: 0 }}
                />
                <TextField
                  type="number"
                  value={earlyBirdDiscount}
                  onChange={(e) => setEarlyBirdDiscount(e.target.value)}
                  sx={discountFieldSx}
                />
                <Typography sx={{ fontSize: isMobile ? "14px" : "16px", color: "#000", flexShrink: 0 }}>
                  {t('DiscountLabel')}
                </Typography>
                <Typography sx={{ fontSize: isMobile ? "13px" : "14px", color: "#000" }}>
                  {t('EarlyBirdPromotionLabel')}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 2, py: 1 }}>
                <FormControlLabel
                  value="addon"
                  control={<Radio sx={radioSx} />}
                  label=""
                  sx={{ mr: 0 }}
                />
                <TextField
                  type="number"
                  value={addonDiscount}
                  onChange={(e) => setAddonDiscount(e.target.value)}
                  sx={discountFieldSx}
                />
                <Typography sx={{ fontSize: isMobile ? "14px" : "16px", color: "#000", flexShrink: 0 }}>
                  {t('DiscountLabel')}
                </Typography>
                <Typography sx={{ fontSize: isMobile ? "13px" : "14px", color: "#000" }}>
                  {t('AddonPromotionLabel')}
                </Typography>
              </Box>

              {customPromotions.map((row, index) => (
                <Box key={row.id} sx={{ display: "flex", alignItems: "center", gap: 2, py: 1 }}>
                  <FormControlLabel
                    value={`custom-${row.id}`}
                    control={<Radio sx={radioSx} />}
                    label=""
                    sx={{ mr: 0 }}
                  />
                  <TextField
                    type="number"
                    value={row.discount}
                    onChange={(e) => updateCustomPromotion(row.id, "discount", e.target.value)}
                    sx={discountFieldSx}
                  />
                  <Typography sx={{ fontSize: isMobile ? "14px" : "16px", color: "#000", flexShrink: 0 }}>
                    {t('DiscountLabel')}
                  </Typography>
                  <TextField
                    placeholder={t('CustomPromotionPlaceholder')}
                    value={row.label}
                    onChange={(e) => updateCustomPromotion(row.id, "label", e.target.value)}
                    sx={customLabelFieldSx}
                  />
                  {index === customPromotions.length - 1 && (
                    <Button
                      onClick={addCustomPromotion}
                      sx={{
                        color: "#31BACD",
                        textTransform: "none",
                        fontSize: isMobile ? "14px" : "16px",
                        minWidth: "auto",
                      }}
                    >
                      {t('AddPromotion')}
                    </Button>
                  )}
                </Box>
              ))}
            </RadioGroup>
          </Box>

          {/* Bottom actions */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              mt: 6,
            }}
          >
            <Button
              onClick={() => navigate("/hotel/onboarding")}
              sx={{
                color: "#666",
                textTransform: "none",
                fontSize: isMobile ? "14px" : "16px",
                textDecoration: "underline",
              }}
            >
              {t('SaveAndLeave')}
            </Button>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                variant="outlined"
                onClick={() => navigate("/hotel/add/room-info-2")}
                sx={{
                  color: "#666",
                  borderColor: "#D1D1D1",
                  borderRadius: "10px",
                  textTransform: "none",
                  fontSize: isMobile ? "14px" : "16px",
                  padding: "10px 32px",
                  "&:hover": { borderColor: "#999", backgroundColor: "transparent" },
                }}
              >
                {t('PreviousStep')}
              </Button>
              <Button
                variant="contained"
                disabled={isNextDisabled}
                onClick={() => navigate("/hotel/add/room-info-add-1")}
                sx={{
                  backgroundColor: "#31BACD",
                  color: "#fff",
                  borderRadius: "10px",
                  textTransform: "none",
                  fontSize: isMobile ? "14px" : "16px",
                  padding: "10px 32px",
                  "&:hover": { opacity: 0.85, backgroundColor: "#31BACD" },
                  "&:disabled": { opacity: 0.5, color: "#fff" },
                }}
              >
                {t('NextStep')}
              </Button>
            </Box>
          </Box>
        </Box>
      </div>
      <Footer />
    </div>
  );
};

export default HotelAdd_RoomInfo_3;
